import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { map, Observable } from 'rxjs';
import { PermissionDirective } from 'src/app/auth/directives/permission/permission.directive';
import { PERMISSIONS } from 'src/app/auth/models/permissions';
import { ProfileService } from 'src/app/auth/services/profile.service';
import { TitleService } from 'src/app/dashboards/services/title.service';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { MenuHeaderComponent } from '../menu/menu-header/menu-header.component';
import { IUserInfo, UserControlComponent } from '../user-control/user-control.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [RouterLink, PermissionDirective, UserControlComponent, AsyncPipe, MenuHeaderComponent],
})
export class HeaderComponent {
  protected title$ = inject(TitleService).headerTitle$;
  protected unreadNotificationsCount$ = inject(NotificationService).getUnreadNotificationsCount();

  protected userInfo$ = new Observable<IUserInfo | undefined>(undefined);
  protected permissions = PERMISSIONS;

  private profileService = inject(ProfileService);

  constructor() {
    this.userInfo$ = this.profileService.getProfile().pipe(
      map((profile) => {
        if (!profile) {
          return undefined;
        }
        return {
          color: profile.colorCode,
          initials: profile.initials,
          displayName: profile.displayName,
          mail: profile.email,
          isLocalAccount: profile.isLocalAccount,
          currentOrganization: profile.currentOrganization ?? null,
        };
      }),
    );
  }
}
